import { SHARE_OPTIONS } from '../constants'
import { trackShareExternallyClicked } from '../events'
import { ShareContextData } from '../provider/ShareContext'
import getEmailDialogUrl from './getEmailDialogUrl'

type OpenEmailDialogParams = {
  link: string
  subject?: string
  body?: string
  emails?: string[]
  shareData?: Partial<ShareContextData>
}

const openEmailDialog = ({
  link,
  subject = '',
  body = '',
  emails,
  shareData = {},
}: OpenEmailDialogParams) => {
  const emailDialogUrl = getEmailDialogUrl(subject, body, emails)

  trackShareExternallyClicked({
    channel: SHARE_OPTIONS.EMAIL,
    link,
    shareData,
    emails,
  })

  window.open(emailDialogUrl)
}

export default openEmailDialog
